/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import { from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  CoralResponse,
  CoralInterceptor,
  CoralRequest,
  CoralHandler,
} from '@amzn/ihm-js-coral-client';
import { RequestInitHeaders } from '@amzn/ihm-js-coral-client/dist/umd/common/headers';
import { CSRF_TOKEN_ID } from '@amzn/carrierlogistics-commons/dist/constants/index';
import getCsrfToken from '@amzn/carrierlogistics-commons/dist/utils/csrf';
import isSiteExternal from '../utils/isSiteExternal';
import { PUMS_NAV_LINK } from '../routes';
import { FAILED_TO_FETCH_ERR_MESSAGES } from '../constants';

// This class is used during client construction, and helps to intercept
// the headers during request handling for the passport external App.
class RequestOptionsInterceptorForPassport extends CoralInterceptor {
  constructor(bindings = {}) {
    super();
    this.bindings = bindings;
  }

  /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  intercept(request: CoralRequest, next: CoralHandler) {
    // Adding required header
    const headers: RequestInitHeaders = [
      ['Accept', 'application/json'],
      ['Content-Type', 'application/json'],
      [CSRF_TOKEN_ID, getCsrfToken()],
    ];
    const postData = request.body;
    // To fix `TypeError: Request constructor: HEAD or GET Request cannot have a body.`
    // Added check to not send stringified body
    const modifiedRequest = request.clone({
      headers,
      credentials: 'include',
      ...(!['GET', 'HEAD'].includes(request?.method)
        ? { body: JSON.stringify(postData) }
        : {}),
    });
    return from(next.handle(modifiedRequest)).pipe(
      map((response) => {
        const { headers: responseHeaders } = response;
        return new CoralResponse(response);
      }),
      catchError((err) => {
        if (
          !isSiteExternal() &&
          err?.message &&
          FAILED_TO_FETCH_ERR_MESSAGES.includes(err?.message)
        ) {
          // Only applicable for internal Passport UI
          // To address Cookie expire issue in pums but once cookie expire, mons returned the request with cors issue
          // In case of err with Failed to Fetch, 403 forbidden status come but this can't be captured in fetch
          // Failed to Fetch can be caused by multiple issue like incorrect url or http methods or CORS issue
          // Since we use CORAL models, issue like incorrect url or http methods is avoided as signature is
          // always same in both UI and backend as models is deployed in both pipelines so only thing left is
          // CORS which can be solved by directly setting the pums mons backend URL with redirect URI
          // Handled the cases for other browsers as well for Chrome, FireFox, Safari, Edge
          window.location.href = PUMS_NAV_LINK;
        }

        return new CoralResponse(err);
      })
    );
  }
}

export default RequestOptionsInterceptorForPassport;
